import request, { REQUEST_METHODS } from '@api/Request';
import { HelpEndpoints } from './config';
import {
  GetHelpStatusResponse,
  SubmitHelpPayload,
  SubmitHelpResponse,
  GetHelpInquirySummaryResponse,
  HelpInquiryRouteParams,
  UpdateHelpInquiryStatusParams,
  UpdateHelpInquiryStatusResponse,
  CancelHelpInquiryStatusResponse,
} from './types';
export default class HelpService {
  public static readonly submitHelp = (data: SubmitHelpPayload): Promise<SubmitHelpResponse> => {
    return request({
      url: HelpEndpoints.submitHelp(),
      method: REQUEST_METHODS.POST,
      data,
    });
  };

  public static readonly getHelpStatus = (): Promise<GetHelpStatusResponse> => {
    return request({
      url: HelpEndpoints.getHelpStatus(),
      method: REQUEST_METHODS.GET,
    });
  };

  public static readonly getHelpInquirySummary = (
    params: HelpInquiryRouteParams
  ): Promise<GetHelpInquirySummaryResponse> => {
    return request({
      url: HelpEndpoints.getHelpInquirySummary(params),
      method: REQUEST_METHODS.GET,
    });
  };

  public static readonly updateHelpInquiryStatus = ({
    requestId,
    version,
    helpInquiryId,
    status,
  }: UpdateHelpInquiryStatusParams): Promise<UpdateHelpInquiryStatusResponse> => {
    return request({
      url: HelpEndpoints.updateHelpInquiryStatus({
        requestId,
        version,
        helpInquiryId,
      }),
      method: REQUEST_METHODS.PATCH,
      data: {
        status,
      },
    });
  };

  public static readonly cancelHelpInquiry = (
    params: HelpInquiryRouteParams
  ): Promise<CancelHelpInquiryStatusResponse> => {
    return request({
      url: HelpEndpoints.cancelHelpInquiry(params),
      method: REQUEST_METHODS.PATCH,
    });
  };
}
